const header = {
  // all the properties are optional - can be left empty or deleted
  homepage: 'https://github.com/timk-dev',
  title: 'TSM.',
}

const about = {
  // all the properties are optional - can be left empty or deleted
  name: 'Timothy Scruggs',
  role: 'Front End Developer',
  description:
    'who emphasizes creating responsive and efficient web apps in React. I love the problem-solving aspect of web development, and I try to tackle each challenge with creativity and precision.',
  // resume: 'https://example.com',
  social: {
    linkedin: 'https://www.linkedin.com/in/timothy-scrmit',
    github: 'https://github.com/timk-dev',
  },
}

const projects = [
  // projects can be added an removed
  // if there are no projects, Projects section won't show up
  {
    name: 'Crumbley',
    description:
      'Recipe App.',
    stack: ['React Vite', 'TheMealDb API', 'react-youtube'],
    sourceCode: '/',
    livePreview: 'https://crumbley.vercel.app/',
  },
  {
    name: 'CastPhere',
    description:
      'Weather App.',
    stack: ['React Vite', 'OpenWeatherApi', 'Chart.js'],
    sourceCode: '/',
    livePreview: 'https://castpherenew.vercel.app/',
  },
  {
    name: 'Online Job Board',
    description:
      'Job board created with the Adzuna API.',
    stack: ['React Vite', 'Adzuna', 'Chart.js'],
    sourceCode: '/',
    livePreview: 'https://needajob-one.vercel.app/',
  },
  {
    name: 'FilmFlix',
    description:
      'FilmFlix is a web app modeled after Netflix and designed to provide comprehensive access to movie information.',
    stack: ['React', 'TMDB API', 'React-youtube', 'CSS3'],
    sourceCode: '/',
    livePreview: 'https://filmflix.strong-concepts.com/',
  },
  {
    name: 'PCI Port-City Interiors',
    description:
      'PCI is a website template for an interior design company.',
    stack: ['HTML5/CSS3', 'JavaScript'],
    sourceCode: '/',
    livePreview: 'https://portcityinteriors.vercel.app/',
  },
]

const skills = [
  // skills can be added or removed
  // if there are no skills, Skills section won't show up
  'HTML',
  'CSS',
  'JavaScript',
  'VSCode',
  'React',
  'Shopify',
  'MongoDb',
  'Material UI',
  'Git',
  'ExpressJs',
  'Postman',
  'Figma',
  'PrimeReact UI',
]

const contact = {
  // email is optional - if left empty Contact section won't show up
  email: 'timothy.scrggsmit89@gmail.com',
}

export { header, about, projects, skills, contact }
